import React, { useState, useEffect } from 'react'
import moment from 'moment-jalaali'
import Button from '@material-ui/core/Button'
import MUIDataTable from 'mui-datatables'
import { ThemeProvider } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import { getDiscounts, deleteDiscount, downloadDiscounts } from '../../app/slices/discountSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'

export const UserList = () => {
  const dispatch = useDispatch()
  const discounts = useSelector((state) => state.discounts.list)
  const count = useSelector((state) => state.discounts.totalHits)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)

  useEffect(() => {
    dispatch(getDiscounts({
      after: page * rowsPerPage,
      first: rowsPerPage,
    }))
  }, [rowsPerPage, page])

  const handleDelete = (list) => {
    const data = list?.data?.map((item) => discounts[item.dataIndex].discountId)
    dispatch(deleteDiscount(data))
  }

  const handleDownlaod = (url) => dispatch(downloadDiscounts(url))

  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
    },
    {
      name: 'code',
      label: 'نام کد تخفیف',
      options: {
        download: true,
        customBodyRenderLite: (dataIndex) => {
          const data = discounts[dataIndex]
          if (!data.code) {
            return (
              <Button
                onClick={() => handleDownlaod(data?.csvUrl)}
                variant="contained"
              >
                دانلود فایل تخفیف‌ها
              </Button>
            )
          }
          return data.code
        },
      },
    },
    {
      name: 'maxUsedCount',
      label: 'تعداد',
    },
    {
      name: 'currentUsedCount',
      label: 'تعداد استفاده شده',
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد کد تخفیف',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: 'expiredDate',
      label: 'تاریخ انقضا کد تخفیف',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
  ]

  return (
    <ThemeProvider theme={getMuiThemeWithoutPadding}>
      <MUIDataTable
        data={discounts}
        columns={COLUMNS}
        options={{
          ...muiDefaultOptions,

          rowsPerPage,
          page,
          count,

          serverSide: true,
          filter: false,
          print: false,
          download: false,
          search: false,

          rowHover: true,
          selectableRows: 'none',
          onRowsDelete: (selectedRows) => handleDelete(selectedRows),
          searchable: false,
          onTableChange: (action, state) => {
            switch (action) {
              case 'changePage': {
                setPage(state.page)
                break
              }
              case 'changeRowsPerPage': {
                setRowsPerPage(state.rowsPerPage)
                break
              }
              default: {
                return null
              }
            }
            return null
          },
        }}
      />
    </ThemeProvider>
  )
}

export default UserList
